import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "src/components/views/HomePage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/")({
	component: HomePage,
});
